Ext.define('SA.SidebarTab', {
    alias: 'widget.sidebar-tab',
    extend: 'Ext.Component',

    cls: 'sa-sidebar-tab',

    initComponent() {
        this.html = [
            '<button disabled class="sa-sidebar-tab-btn">',
                `<svg aria-hidden="true" class="sa-sidebar-tab-icon"><use href="${this.iconHref}"></use></svg>`,
                `<span class="sa-sidebar-tab-label">${this.label}</span>`,
            '</button>'
        ];

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.el.on('mouseenter', this.onMouseOver, this);
    },

    afterRender() {
        this.callParent();

        this.btnEl = this.el.down('button');
        this.btnEl.on('click', this.onClick, this);
    },

    getDom() {
        return this.el.dom;
    },

    hasType(type) {
        return Ext.Array.from(type).includes(this.type);
    },

    isEnabled() {
        return !this.btnEl.dom.disabled;
    },

    isSelected() {
        return this.el.hasCls('sa-sidebar-tab-btn-selected');
    },

    onClick() {
        this.fireEvent('click', this.type);
    },

    onMouseOver() {
        this.fireEvent('mouseover', this);
    },

    setEnabled(enabled) {
        this.btnEl.dom.disabled = !enabled;
    },

    setSelected(selected) {
        this.btnEl.ifCls(selected, 'sa-sidebar-tab-btn-selected');
    }
});
